import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import {injectStripe} from 'react-stripe-elements';
import {observer} from 'mobx-react';

@observer
class PaymentRequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.displayPaymentRequestButtonIfSupported();
  }

  initializePaymentRequest = () => this.props.stripe.paymentRequest({
    country: store.donateForm.defaultOrSelectedBillingCountry,
    currency: store.donateForm.currencyName,
    total: {
      label: this.buttonText(),
      amount: Math.round(store.donateForm.amount * 100),
    },
    requestPayerName: true,
    requestPayerEmail: !store.donateForm.isUserLoggedIn,
  });

  displayPaymentRequestButtonIfSupported = () => {
    const paymentRequest = this.initializePaymentRequest();

    paymentRequest.canMakePayment().then((result) => {
      store.donateForm.supportsPaymentRequestButton = !!result;
      if (result) store.donateForm.supportsApplePay = result.applePay;
    });
  }

  addPaymentRequestListeners = (paymentRequest) => {
    paymentRequest.on('paymentmethod', (event) => {
      this.props.trackPayButtonClick({
        button_type: 'Payment Request Button',
      });

      if (!store.donateForm.isUserLoggedIn) store.donateForm.email = event.payerEmail;
      store.donateForm.setNameAndSurnameFromPayerName(event.payerName);
      store.donateForm.formAction = this.props.formAction;

      if(!this.props.validateForm()) {
        store.donateForm.disableFormSubmit = false;
        store.donateForm.disableEditAmount = false;
        event.complete('fail');
        return false;
      }

      if(store.donateForm.isSubscription) {
        if(!store.donateForm.disableMembershipCheck) {
          $.getJSON(`/api/v1/spring_membership/${store.donateForm.email}`, (data) => {
            store.donateForm.isAlreadySpringMember = data['is_spring_member'];
            store.donateForm.existingMembershipCountry = data['existing_membership_country'];
            if(!store.donateForm.isAlreadySpringMember) {
              this.handleForSubscription(event);
            } else {
              event.complete('fail');
            }
          });
        } else {
          this.handleForSubscription(event);
        }
      } else {
        this.handleForDonation(event);
      }
    });

    paymentRequest.on('cancel', () => {
      store.donateForm.disableFormSubmit = false;

      window.analytics.track(
        'Canceled Payment Request Modal',
        {
          campaign_slug: store.donateForm.campaignSlug,
          campaign_type: store.donateForm.campaignType,
        },
      );
    });
  }

  handleForSubscription = (event) => {
    store.donateForm.createSetupIntent(() => {
      store.donateForm.createOrUpdateDonationForm('stripe', ({redirectUrl}) => {
        this.props.stripe.handleCardSetup(store.donateForm.setupIntentSecret, {
          payment_method: event.paymentMethod.id,
        }).then((response) => {
          if(response.error) {
            store.donateForm.handlePaymentRequestError(response.error.message);
            event.complete('fail');
          } else {
            event.complete('success');
            window.location = redirectUrl;
          }
        });
      }, ({error}) => {
        store.donateForm.handlePaymentRequestError(error);
      });
    });
  }

  handleForDonation = (event) => {
    store.donateForm.createOrUpdatePaymentIntent(() => {
      store.donateForm.createOrUpdateDonationForm('stripe', ({redirectUrl}) => {
        this.props.stripe.handleCardPayment(store.donateForm.paymentIntentSecret, {
          payment_method: event.paymentMethod.id,
        }).then((response) => {
          if(response.error) {
            store.donateForm.handlePaymentRequestError(response.error.message);
            event.complete('fail');
          } else {
            store.donateForm.formAction = this.props.formAction;
            event.complete('success');
            window.location = redirectUrl;
          }
        });
      }, ({error}) => {
        store.donateForm.handlePaymentRequestError(error);
      });
    });
  }

  buttonText = () => {
    const paymentRequestLabel = store.donateForm.isSubscription ? 'Donate Monthly' : 'Donate';
    const applePayLabel = store.donateForm.isSubscription ? 'charity: water Monthly' : 'charity: water';
    return store.donateForm.supportsApplePay ? applePayLabel : paymentRequestLabel;
  }

  handleClick = () => {
    const paymentRequest = this.initializePaymentRequest();
    this.addPaymentRequestListeners(paymentRequest);

    paymentRequest.canMakePayment().then(() => {
      store.donateForm.disableFormSubmit = true;
      store.donateForm.disableEditAmount = true;
      paymentRequest.show();
    });
  }

  render() {
    return store.donateForm.supportsPaymentRequestButton ? (
      <>
        <a
          className={cx('express-donate-button button button--cw-black w-full relative mb-1 mt-2 text-center', {'apple-pay-button apple-pay-button-black': store.donateForm.supportsApplePay, 'disabled': store.donateForm.disableFormSubmit})}
          onClick={this.handleClick}
        >
          {
            store.donateForm.supportsApplePay ? '' : (
              <>
                Express Donate
                <span className='cw-icon-double-angle-right absolute pl-1 sm-text-lg md-text-xl' />
              </>
            )
          }
        </a>
        {store.donateForm.paymentRequestButtonError &&
          <small className='leading-normal error text-cw-red text-center my-1'>
            {store.donateForm.paymentRequestButtonError}
          </small>
        }
        <div className='text-separator relative z-10 -mb-1'>
          <span className='text-small'>or enter your details manually below</span>
        </div>
      </>
    ) : null;
  }
}

export default injectStripe(PaymentRequestForm);
